import { css } from "@vitality-ds/system";
export default css({
  marginRight: "$md"
});